<ng-container #inner></ng-container>
